import { ref } from 'vue'
import { useFetch } from '@vueuse/core'

export const useToken = () => {
  const token = ref(null)
  const tokenError = ref(null)
  const isLoading = ref(false)

  const getCSRFToken = async () => {
    if (typeof window === 'undefined') {
      token.value = null
      tokenError.value = new Error('Window is not available')
      return {
        token: token.value,
        error: tokenError.value
      }
    }

    isLoading.value = true
    tokenError.value = null

    const { data, error } = await useFetch(`${window.location.origin}/session/token`).text()

    if (error.value) {
      token.value = null
      tokenError.value = error.value
    } else {
      token.value = data.value
    }

    isLoading.value = false

    return {
      token: token.value,
      error: tokenError.value
    }
  }

  return {
    token,
    tokenError,
    isLoading,
    getCSRFToken
  }
}
